import getAxios from '../../clients';
import { REPORTS_URL } from '../../config';

export const getDashboard = async (jwt: string, id: string) => {
  const result = await getAxios.instance(jwt).get(`${REPORTS_URL}/metabase/dashboard/${id}`);

  return result.data.url;
};
